export const FACILITY_NEXT_STATES_LIST_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFacility.FacilityNextStatesListComputed";
export const FACILITY_NEXT_STATES_LIST_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFacility.FacilityNextStatesListInvalidated";
export const FACILITY_STATE_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingFacility.FacilityStateUpdated";
